export type CookieName =
  | "tkn"
  | "primary"
  | "secondary"
  | "info"
  | "logoUrl"
  | "logoPadding"
  | "bannerLogoUrl"
  | "bannerPadding"
  | "lastUrl"
  | "user"
  | "companyPath"
  | "lang";

export const setCookieValue = (cookieName: CookieName, value: string) => {
  const date = new Date();
  date.setTime(date.getTime() + 2000 * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();

  document.cookie = cookieName + "=" + (value || "") + expires + "; path=/";
};

export const deleteCookie = (cookieName: CookieName) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

export const getCookieValue = (cookieName: CookieName): string => {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(cookieName))
      ?.split("=")[1] || ""
  );
};
